import type FilePickerViewState from '../store/schema/FilePickerViewState';
import type { FileProviderViewState } from 'owa-fileprovider-store';
import { action } from 'satcheljs/lib/legacy';
import { getFileProviderInfo } from '../utils/fileProviderInfo';
import changeFilePickerView from './changeFilePickerView';

export default action('changeSelectedFilePickerViewBasedOnUserPreferredView')(
    function changeSelectedFilePickerViewBasedOnUserPreferredView(
        selectedFileProvider: FileProviderViewState,
        viewState: FilePickerViewState
    ) {
        // Change the view to user preferred view type if supported by provider else the default one
        const fileProviderInfo = getFileProviderInfo(selectedFileProvider.type);
        const userPrefferedViewType = viewState.userPreferredViewType;
        const userPrefferedViewIndex = fileProviderInfo.supportedFilePickerViews.indexOf(
            userPrefferedViewType
        );
        const viewToSwitchTo =
            userPrefferedViewIndex !== -1
                ? fileProviderInfo.supportedFilePickerViews[userPrefferedViewIndex]
                : fileProviderInfo.supportedFilePickerViews[0];
        changeFilePickerView(viewToSwitchTo, selectedFileProvider, viewState);
    }
);
